import api from './api';

export type AgencyPublicData = {
  name: string;
  slug: string;
  bannerImageData?: string;
  bannerImageType?: string;
};

export const getAgencyPublicData = async (slug: string): Promise<AgencyPublicData> => {
  const response = await api.get<AgencyPublicData>(`/agencies/${slug}/public`);
  return response.data;
};
